import api from "@/api";
import { find as Rfind, propEq as RpropEq } from "ramda";
import { JSConn } from "@/utilities/js-conn";

const itemDetails = {
  pluralName: "work_order_task_line_items",
  singularName: "work_order_task_line_item",
};

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    work_order_task_line_item: {
      ...jsConn.formParams,
    },
  };
};
interface WorkOrderTaskLineItem {
  id: string;
  name: string;
  description: string;
  start_date: string;
  completed_date: null | string;
  status: string;
  sort_order: number;
  work_order_id: string;
}

interface WorkOrderTaskLineItemState {
  workOrderTaskLineItems: WorkOrderTaskLineItem[];
  workOrderTaskLineItem: WorkOrderTaskLineItem | {};
}

const state: WorkOrderTaskLineItemState = {
  workOrderTaskLineItems: [],
  workOrderTaskLineItem: {},
};

const mutations = {
  LOAD_WORK_ORDER_TASK_LINE_ITEMS(
    state: WorkOrderTaskLineItemState,
    payload: WorkOrderTaskLineItem[],
  ) {
    state.workOrderTaskLineItems = payload;
  },
  LOAD_WORK_ORDER_TASK_LINE_ITEM(
    state: WorkOrderTaskLineItemState,
    payload: WorkOrderTaskLineItem,
  ) {
    state.workOrderTaskLineItem = payload;
  },
};

const actions = {
  needWorkOrderTaskLineItems(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api.getItems(jsConn, itemDetails).then(
      (jsConn: JSConn): Promise<JSConn> => {
        context.commit("LOAD_WORK_ORDER_TASK_LINE_ITEMS", jsConn.response);
        return Promise.resolve(jsConn);
      },
    );
  },
  deleteWorkOrderTaskLineItem(_context: any, jsConn: JSConn) {
    // set the api params to be correct
    // this may be called from multiple places
    // as of 2019-03-22 it is just called from the
    // workorder show page and there the entire lineItem
    // is being set as the form params
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .deleteItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
  createWorkOrderTaskLineItem(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .createItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        context.commit("LOAD_WORK_ORDER_TASK_LINE_ITEM", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
  updateWorkOrderTaskLineItem(_context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;

    return api
      .updateItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
};

const getters = {
  workOrderTaskLineItems: (state: WorkOrderTaskLineItemState) =>
    state.workOrderTaskLineItems,

  workOrderTaskLineItemById: (state: WorkOrderTaskLineItemState) => (
    id: string,
  ) => {
    return Rfind(task => {
      return RpropEq("id", id, task);
    }, state.workOrderTaskLineItems);
  },
};

const workOrderTaskLineItemsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default workOrderTaskLineItemsModule;
